"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var getOffsetParent_1 = tslib_1.__importDefault(require("../getOffsetParent"));
var getRegion_1 = tslib_1.__importDefault(require("../getRegion"));
var getVisibleRectForElement_1 = tslib_1.__importDefault(require("../getVisibleRectForElement"));
var align_1 = tslib_1.__importDefault(require("./align"));
function isOutOfVisibleRect(target, alwaysByViewport) {
    var visibleRect = (0, getVisibleRectForElement_1.default)(target, alwaysByViewport);
    var targetRegion = (0, getRegion_1.default)(target);
    return (!visibleRect ||
        targetRegion.left + targetRegion.width <= visibleRect.left ||
        targetRegion.top + targetRegion.height <= visibleRect.top ||
        targetRegion.left >= visibleRect.right ||
        targetRegion.top >= visibleRect.bottom);
}
function alignElement(el, refNode, align, alignConfig, adjustCenter) {
    var target = align.target || refNode;
    var refNodeRegion = (0, getRegion_1.default)(target);
    var isTargetNotOutOfVisible = !isOutOfVisibleRect(target, align.overflow && align.overflow.alwaysByViewport);
    return (0, align_1.default)(el, refNodeRegion, align, isTargetNotOutOfVisible, alignConfig, adjustCenter);
}
alignElement.__getOffsetParent = getOffsetParent_1.default;
alignElement.__getVisibleRectForElement = getVisibleRectForElement_1.default;
exports.default = alignElement;
//# sourceMappingURL=alignElement.js.map